import { Pipe, PipeTransform } from '@angular/core';
import { FinancialAccountType } from '../../../../data/src/lib/entities/treasury.model';

const LABELS: Record<FinancialAccountType, string> = {
  [FinancialAccountType.Cash]: 'Conta Caixa',
  [FinancialAccountType.Bank]: 'Conta Bancária',
  [FinancialAccountType.Wallet]: 'Conta Digital',
  [FinancialAccountType.Investment]: 'Investimento',
};

@Pipe({ name: 'financialAccountTypeLabel', standalone: true, pure: true })
export class FinancialAccountTypeLabelPipe implements PipeTransform {
  transform(value: FinancialAccountType): string {
    return LABELS[value];
  }
}
